<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="errorMessage" :mensagem="errorMessage" />

    <div class="form-edit-page row-space">
        <div class="row-start">
            <div class="form-item-char40">
                <label class="label-caption">Opções de Relatório</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item-rangedata"><DateRangeSelect v-model="dateRange" /></div>
            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>

</template>

<script setup>
import { ref } from 'vue';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { Funcoes } from '@/funcoes/utils';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const errorMessage = ref(null);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'manut_veiculo_executadas', descricao: 'OS executadas por veículo'},
    {id: 'manut_veiculo_servicos', descricao: 'Serviços por veículo'},
]);
const opcaoSelecionada = ref('manut_veiculo_executadas');

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        errorMessage.value = null;
        isLoading.value = true;
        let informacoes = `Período: ${Funcoes.formatDateFromJson(dateRange.value.startDate)} a ${Funcoes.formatDateFromJson(dateRange.value.endDate)}`;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            informacoes: informacoes,
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){errorMessage.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>